var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 177,
    viewBox: "0 0 176 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88.2637,
    r: 85.5,
    fill: "white",
    stroke: "url(#paint0_linear_2440_21826)",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.091 80.9919L115.165 81.3664L115.546 81.3937C125.002 82.0691 132.5 89.8817 132.5 99.5137C132.5 109.588 124.324 117.764 114.25 117.764H65.5C53.3449 117.764 43.5 107.919 43.5 95.7637C43.5 84.416 52.0981 75.0837 63.1163 73.892L63.3815 73.8633L63.5054 73.627C68.1293 64.8029 77.3568 58.7637 88 58.7637C101.407 58.7637 112.586 68.3216 115.091 80.9919ZM80.1464 107.367L80.5 107.721L80.8536 107.367L105.566 82.6547L105.92 82.3012L105.566 81.9476L100.26 76.6414L99.9062 76.2878L99.5527 76.6414L80.5 95.6941L73.0348 88.2289L72.6812 87.8753L72.3277 88.2289L67.0214 93.5351L66.6679 93.8887L67.0214 94.2422L80.1464 107.367Z",
    fill: "url(#paint1_linear_2440_21826)",
    stroke: "url(#paint2_linear_2440_21826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2440_21826",
    x1: 0,
    y1: 176.264,
    x2: 132.876,
    y2: 131.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2440_21826",
    x1: 43,
    y1: 118.264,
    x2: 103.335,
    y2: 87.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2440_21826",
    x1: 43,
    y1: 118.264,
    x2: 103.335,
    y2: 87.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.83cbbf4b955c72be55739cbbb420c637.svg";
export { ForwardRef as ReactComponent };